/* ==========================================================================
   SearcherFerryHotel > Client > AddRoom
   ========================================================================== */
/* Modules */
const { addStyle, addData } = require('@bluekiri/alexandria/helpers/dataHelpers');

const ButtonTemplate = require('@bluekiri/alexandria-contrib-components/components/button-rxjs/template');
const ButtonClient = require('@bluekiri/alexandria-contrib-components/components/button-rxjs/client/js');
const configuration = require('../../config');

function renderAddRoom(instance) {
    const { config = {} } = instance;
    const { context = {}, literals = {} } = config;
    const { addRoom = '' } = literals;

    const dataButton = addStyle(addData({ content: addRoom }, { type: configuration().type.addRoom }), [
        'button-rxjs--add'
    ]);

    return ButtonTemplate(dataButton, context);
}

function initAddRoom(instance) {
    const result = instance;
    const { subscriptions = {}, accommodationInput, accommodation } = instance;

    /* Data Panel */
    const { panelType } = accommodationInput.store.select('data');
    const panelSelector = `[data-type="${panelType}"]`;

    result.addRooms = ButtonClient(
        `${panelSelector} [data-component="ButtonRxjs"][data-type="${configuration().type.addRoom}"]`
    );

    if (result.addRooms) {
        /* Extends subscriptions */
        result.subscriptions = {
            ...subscriptions,
            addRooms: result.addRooms.events.click$.subscribe(event => {
                event.stopPropagation();

                /* Data Store */
                const { error } = accommodation.store.select('data');

                if (error) result.addRooms.actions.disable();

                accommodation.actions.addRoom();

                /* scroll to last room added */
                result.hooks.panelBody.scrollTop = result.hooks.panelBody.scrollHeight;
            })
        };
    }
}

function destroyAddRoom(instance) {
    const result = instance;
    if (!instance.addRooms) return;

    instance.addRooms.actions.destroy();

    instance.subscriptions.addRooms.unsubscribe();

    /* Remove references */
    delete result.addRooms;
    delete result.subscriptions.addRooms;
}

module.exports = {
    renderAddRoom,
    initAddRoom,
    destroyAddRoom
};
